/**
 * RainbowKit chrome follows the active design mode — Eclipse is dark, Groky uses a black accent.
 */
import React, { useMemo } from 'react';
import { RainbowKitProvider, darkTheme, lightTheme } from '@rainbow-me/rainbowkit';
import { useDesignMode } from '../context/DesignModeContext';

const ECLIPSE_WALLET_THEME = darkTheme({
  accentColor: '#000000',
  accentColorForeground: '#f8fafc',
});

const GROKY_WALLET_THEME = lightTheme({
  accentColor: '#0a0a0a',
  accentColorForeground: '#ffffff',
});

export function RainbowKitThemeProvider({ children }: { children: React.ReactNode }) {
  const { designMode } = useDesignMode();
  const theme = useMemo(() => {
    if (designMode === 9) return ECLIPSE_WALLET_THEME;
    if (designMode === 10) return GROKY_WALLET_THEME;
    return lightTheme();
  }, [designMode]);

  return <RainbowKitProvider theme={theme}>{children}</RainbowKitProvider>;
}
